export { default } from './isImmutableMap'
